var module = angular.module('octopusApp.projects');

module.directive('progressionMatrix', function(octoUtil, taskStatusRenderer, octopusPermissionSet, octopusRepository, $q) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      progression: '=',
      project: '='
    },
    link: function(scope, element) {
      var previousHeadings = "";
      var channels;

      function fullRenderRequired(slice) {
        var headings = angular.toJson({ a: slice.environments, b: slice.releases });
        var required = headings !== previousHeadings;
        previousHeadings = headings;
        return required;
      }

      function nodeKey(envId, releaseId) { return [envId, "__", releaseId].join(''); }

      function sliceProgression(data) {
        var slice = {
          releases: [],
          environments: data.Environments,
          channelEnvironments: data.ChannelEnvironments,
          environmentsById: _.object(_.pluck(data.Environments, 'Id'), data.Environments),
          items: {},
          progressions: {}
        };

        var permissions = [];
        _.each(data.Releases, function (row) {
          row.Release.isBlocked = row.HasUnresolvedDefect;
          slice.releases.push(row.Release);

          _.each(row.Deployments, function(deployments, iter) {
            _.each(deployments, function(deployment) {
              var key = nodeKey(iter, deployment.ReleaseId);
              if (!slice.items[key]) {
                slice.items[key] = deployment;
              }
            });
          });

          _.each(row.NextDeployments, function(next) {
            var key = nodeKey(next, row.Release.Id);
            permissions.push(
                octopusPermissionSet.isAuthorized(
                    {permission: "DeploymentCreate", projectId: scope.project.Id, environmentId: next}
                ).then(function (allowed) {
                  if (allowed) {
                    slice.progressions[key] = {release: row.Release.Version, envId: next};
                  }
                })
            );
          });
        });

        return $q.all(permissions).then(function() {
          return slice;
        });
      }

      function sliceByChannel(data) {
        var slices = {};
        _.each(channels, function (channel) {
          slices[channel.Id] = {
            channelId: channel.Id,
            releases: [],
            environments: data.channelEnvironments[channel.Id] || data.environments,
            items: {},
            progressions: data.progressions
          };
          var environments = slices[channel.Id].environments;
          slices[channel.Id].environmentsById = _.object(_.pluck(environments, 'Id'), environments);
        });

        _.each(data.releases, function (release) {
          slices[release.ChannelId].releases.push(release);
        });

        return slices;
      }

      function getItemsForChannel(releases, items, channelId) {
        var itemDictionary = {};

        _.each(releases, function(release) {
          if (release.ChannelId === channelId) {
            var releaseId = release.Id;
            _.each(items, function (item) {
              if (item.ReleaseId === releaseId) {
                var itemKey = nodeKey(item.EnvironmentId, item.ReleaseId);
                if (!itemDictionary[itemKey]) {
                    itemDictionary[itemKey] = [];
                }
                itemDictionary[itemKey].push(item);
              }
            });
          }
        });

        return itemDictionary;
      }

      function sortChannelsByDefaultThenByName() {
        return channels.sort(function(channelA, channelB) {
          return (
            // Sort by default channel first
            channelA.IsDefault === channelB.IsDefault ? 0 
            : channelA.IsDefault ? -1 
            : 1) || (
            // Then sort by name alphabetically
            channelA.Name.toLowerCase() === channelB.Name.toLowerCase() ? 0 
            : channelA.Name.toLowerCase() < channelB.Name.toLowerCase() ? -1 
            : 1);
        });
      }

      var matrices = [];

      function renderDashboard(slice, heading) {
        var matrixElement = $("<div></div>");
        element.append(matrixElement);
        var matrix = new Octopus.ReleaseMatrix(matrixElement, taskStatusRenderer, octoUtil);

        matrix.environments = slice.environments;
        matrix.environmentsById = slice.environmentsById;
        matrix.rows = slice.releases;
        matrix.heading = heading;
        matrix.items = slice.items;
        matrix.progressions = slice.progressions;
        if (channels.length > 1) {
          matrix.slice = slice;
        }
        matrix.keyFromPair = function (env, release) { return nodeKey(env.Id, release.Id); };
        matrix.renderEmptyRow = function (html) {
          html.push('<tr>');
          html.push('<td class="no-bottom-border" colspan="' + (matrix.environments.length + 1) + '">');
          html.push('<p class="empty-row-state">There are no releases for this channel yet. ');
          html.push('<a href="#/projects/' + scope.project.Slug + '/releases/create');
          if (slice.channelId) {
            html.push('?channelId=' + slice.channelId);
          }
          html.push('">Create a release</a>.');
          html.push('</p>');
          html.push('</td>');
          html.push('</tr>');
        };
        matrix.renderRowHeading = function (release, html) {
          if (release.isBlocked) {
            html.push('<div class="unresolved-defect" title="This release has been blocked from future deployments. View the release details for more information."><i class="fa fa-exclamation-triangle"></i></div>');
          }
          html.push('<a class="project-name" href="#/projects/');
          html.push(scope.project.Slug);
          html.push('/releases/');
          html.push(release.Version);
          html.push('">');
          html.push(octoUtil.escapeHtml(release.Version));
          html.push('</a>');
        };
        matrix.renderEmptyCell = function(key, html) {
          var progression = matrix.progressions[key];
          if (progression) {
            html.push('<div class="deploy-buttons">');
            html.push('<a class="btn" href="#/projects/');
            html.push(scope.project.Slug);
            html.push('/releases/');
            html.push(progression.release);
            html.push('/deployments/create/to/');
            html.push(progression.envId);
            html.push('">Deploy</a>');
            html.push('</div>');
          }
        };

        matrix.render();
        matrices.push(matrix);
      }

      function fullRender(data) {
        sliceProgression(data).then(function(slice) {
          if (channels.length < 2) {
            renderDashboard(slice, "Release");
          } else {
            var channelSlices = sliceByChannel(slice);
            var items = slice.items;

            var sortedChannels = sortChannelsByDefaultThenByName();

            _.each(sortedChannels, function (channel) {
              var channelSlice = channelSlices[channel.Id];

              channelSlice.items = getItemsForChannel(channelSlice.releases, items, channel.Id);
              renderDashboard(channelSlice, "Channel: " + channel.Name);
            });
          }
        });
      }

      function partialRender(data) {
        sliceProgression(data).then(function(slice) {
          _.each(matrices, function (matrix) {
            if (matrix.slice) {
              matrix.environments = slice.channelEnvironments[matrix.slice.channelId] || slice.environments;
              matrix.items = getItemsForChannel(slice.releases, slice.items, matrix.slice.channelId);
              matrix.rows = _.filter(slice.releases, function (release) { return release.ChannelId === matrix.slice.channelId; });
              matrix.progressions = slice.progressions;
            } else {
              matrix.environments = slice.environments;
              matrix.items = slice.items;
              matrix.rows = slice.releases;
              matrix.progressions = slice.progressions;
            }
            matrix.render();
          });
        });
      }

      scope.$watch('progression', updateDisplay, true);
      scope.$watch('project', updateDisplay, true);

      function updateDisplay() {
        if (!scope.project || !scope.progression) {
          return;
        }

        if(channels) {
          if (fullRenderRequired(scope.progression)) {
            fullRender(scope.progression);
          } else {
            partialRender(scope.progression);
          }
        } else {
          octopusRepository.Projects.getChannels(scope.project).then(function (c) {
            channels = c.Items;
            updateDisplay();
          });
        }
      }
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/directives/progression_matrix.js
// module id = 1516088312948305
// module chunks = 1